export default {
  productName: 'Free-Standing Boxing Bag',
  pathId: 'fightcamp-boxing-bag',
  description: 'Recognized as the best bag on the market, the FightCamp Free-Standing Boxing Bag combines sleek design with unmatched durability. It holds about 250 lbs of water or 350 lbs of sand (use sand for extra stability).',
  shortDescription: 'The FightCamp Free-Standing Boxing Bag is the best free-standing bag on the market.',
  isSoldOut: false,
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/800x800/b43e0636c6/bag.jpg',
    alt: 'Boxing bag',
  },
  lifestyleImage: {
    src: 'https://a.storyblok.com/f/152150/1648x1648/ea6b30a5cc/fc-freestanding-bag-ring.jpg',
    alt: 'Boxing bag',
  },
  includesModalCopy: {},
  assets: [],
  features: [
    {
      title: 'Features',
      copy: [
        'Free-standing heavy bag with secure base and top construction',
        'High-density foam interior with durable vinyl cover',
        'Hook-and-loop tension belts secure top to base',
        'Easy to install and reposition with tilt-and-roll design',
      ],
    },
    {
      title: 'Size & Fit',
      copy: [
        'Bag height: 67" when fully assembled',
        'Bag Top diameter: 18". Bag Base diameter: 24"',
        'Unfilled base weight: base 13 lbs, top 17 lbs',
        'Filled base weight: up to 250 lbs with water or 350 lbs with sand',
      ],
    },
    {
      title: 'Materials & Care',
      copy: [
        'High-density foam interior, vinyl exterior',
        'Wipe clean with a damp cloth; store indoors when not in use',
      ],
    },
  ],
};
